import { render, staticRenderFns } from "./Qbet.vue?vue&type=template&id=c8145344&scoped=true&"
import script from "./Qbet.vue?vue&type=script&lang=js&"
export * from "./Qbet.vue?vue&type=script&lang=js&"
import style0 from "./Qbet.vue?vue&type=style&index=0&id=c8145344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8145344",
  null
  
)

export default component.exports